<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="cancel()">Cancel</ion-button>
    </ion-buttons>
    <ion-title>{{ title }}</ion-title>
    <ion-buttons slot="end">
      <ion-button
        (click)="confirm()"
        type="submit"
        [strong]="true"
        [disabled]="!tankFormDetails.valid"
      >
        {{ isOnboarding ? 'Get Started' : 'Add' }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <!-- Onboarding message -->
  @if (isOnboarding) {
    <div class="onboarding-message">
      <ion-icon name="fish" class="onboarding-icon"></ion-icon>
      <p>
        Your tank is the foundation of your reef tracking journey. Once set up,
        you'll be able to track water parameters, monitor corals, and keep a
        detailed timeline of your reef's progress.
      </p>
    </div>
  }

  <form [formGroup]="tankFormDetails">
    <ion-list>
      <ion-item lines="none">
        <ion-label position="stacked">Tank Name</ion-label>
        <ion-input
          formControlName="name"
          placeholder="e.g., Living Room Reef, Nano Tank"
        ></ion-input>
      </ion-item>
      <ion-item lines="none">
        <ion-label position="stacked">Tank Size (Gallons)</ion-label>
        <ion-input
          type="number"
          formControlName="gallons"
          placeholder="e.g., 75"
        ></ion-input>
      </ion-item>
    </ion-list>
  </form>

  <!-- Helpful tip for onboarding -->
  @if (isOnboarding) {
    <ion-note class="onboarding-tip">
      <ion-icon name="bulb-outline"></ion-icon>
      Tip: You can add more tanks later in Settings.
    </ion-note>
  }
</ion-content>

